import ChartDataSelector from './ChartDataSelector';

export default ChartDataSelector;
